import Script from 'next/script';

export function Tweet({
	                      url,
                      }) {
	return (<div className="not-prose flex justify-center">
		<blockquote className="twitter-tweet">
			<a href={url}>Tweet loading...</a>
		</blockquote>

		<Script src="https://platform.twitter.com/widgets.js" />
	</div>);
}
